export default "__VITE_ASSET__RXRV_w5Z__"